<template>
  <div :class="containerClasses" style="display: block">
    <PeriodPickerHeader
      :header-text="visibleYear.label"
      :has-next-page="hasNextPage"
      :has-previous-page="hasPreviousPage"
      @show-next-page="showNextPage"
      @show-previous-page="showPreviousPage"
      @headerClick="$emit('year-click')"
    />
    <div
      v-for="(row, row_index) in periodsInRows"
      :key="`months-row-${row_index}`"
      :class="rowNames"
    >
      <span
        v-for="(period, period_index) in row"
        :key="`month-${period_index}`"
        :class="periodClasses(period)"
        class="period-picker-item"
        @click="handlePeriodClick(period)"
      >
        {{ period.label }}
        <i v-show="period.private && period.ledgerId" class="fa fa-eye-slash" />
      </span>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import classNames from 'classnames'

import PeriodPickerHeader from './period-picker-header'
import PeriodPickerMixin from './period-picker-mixin'

const PeriodPickerMonths = {
  components: {
    PeriodPickerHeader,
  },
  mixins: [PeriodPickerMixin],
  props: {
    years: Array,
    ledgersPerYear: Number,
    currentLedgerId: Number,
    highlightedPeriod: Object,
    focusedYear: Object,
  },
  emits: ['period-click', 'year-click'],
  data() {
    return {
      visibleYear: this.focusedYear,
    }
  },
  computed: {
    yearsWithPeriods() {
      const years = this.years

      const firstYear = years.findIndex((year) => this.hasPeriodsWithData(year))
      const lastYear = _.findLastIndex(years, (year) =>
        this.hasPeriodsWithData(year)
      )

      return years.slice(firstYear, lastYear + 1)
    },
    currentPeriods() {
      return this.visibleYear.periods
    },
    hasPreviousPage() {
      return this.visibleYearIndex > 0
    },
    hasNextPage() {
      return this.visibleYearIndex < this.yearsWithPeriods.length - 1
    },
    periodsInRows() {
      return _.chunk(this.currentPeriods, 4)
    },
    containerClasses() {
      return classNames({
        'periodpicker-months': this.ledgersPerYear === 12,
        'periodpicker-quarters': this.ledgersPerYear === 4,
        'periodpicker-years': this.ledgersPerYear === 1,
      })
    },
    rowNames() {
      return classNames({
        'periodpicker-months-row': this.ledgersPerYear === 12,
        'periodpicker-quarters-row': this.ledgersPerYear === 4,
        'periodpicker-years-row': this.ledgersPerYear === 1,
      })
    },
    nextYearClass() {
      return classNames({
        'not-visible': !this.hasNextPage,
      })
    },
    previousYearClass() {
      return classNames({
        'not-visible': !this.hasPreviousPage,
      })
    },
    visibleYearIndex() {
      return this.yearsWithPeriods.findIndex((year) =>
        _.isEqual(year, this.visibleYear)
      )
    },
  },
  watch: {
    focusedYear(newValue) {
      this.visibleYear = newValue
    },
  },
  methods: {
    periodClasses(period) {
      return classNames({
        month: this.ledgersPerYear === 12,
        quarter: this.ledgersPerYear === 4,
        private: period.private && period.ledgerId,
        active: _.isEqual(period, this.highlightedPeriod),
        disabled: !period.ledgerId,
      })
    },
    showPreviousPage() {
      const years = this.yearsWithPeriods
      this.visibleYear = years[this.visibleYearIndex - 1]
    },
    showNextPage() {
      const years = this.yearsWithPeriods
      this.visibleYear = years[this.visibleYearIndex + 1]
    },
    handlePeriodClick(period) {
      if (period.ledgerId) {
        this.$emit('period-click', period)
      }
    },
  },
}

export default PeriodPickerMonths
</script>
